



















































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import lineChart from "../charts/lineReactive.vue";
import { Getter, Action } from "vuex-class";
import { Team, TeamPerformance } from "../../types";

@Component({
  components: {
    lineChart
  }
})
export default class TeamPerformanceChart extends Vue {
  @Action private fetchTeamPerformanceOverall!: (id: Number) => any;
  @Action private fetchTeamPerformancePace!: (id: Number) => any;
  @Action private fetchTeamPerformanceConciseness!: (id: Number) => any;
  @Action private fetchTeamPerformanceFillers!: (id: Number) => any;

  @Getter private currentTeamID?: number;
  @Getter private teamPerformanceOverall!: TeamPerformance;
  @Getter private teamPerformancePace!: TeamPerformance;
  @Getter private teamPerformanceFillers!: TeamPerformance;
  @Getter private teamPerformanceConciseness!: TeamPerformance;

  private currentChart: string = "overall";
  private datacollection: any = {};
  private dataUpdated: boolean = false;

  private created() {
    if(this.teamPerformanceOverall!=null)
      this.teamPerformanceOverallData()
    
    this.fetchData();
  }

  @Watch("currentTeamID")
  private onCurrentTeamIdChanged(newVal: string, oldVal: string) {
    if (newVal && newVal !== oldVal) {
      this.fetchData();
    }
  }

  private fetchData() {
    this.fetchTeamPerformanceOverall(this.currentTeamID!);
    this.fetchTeamPerformancePace(this.currentTeamID!);
    this.fetchTeamPerformanceConciseness(this.currentTeamID!);
    this.fetchTeamPerformanceFillers(this.currentTeamID!);
  }

  private options: any = {
    scales: {
      yAxes: [
        {
          gridLines: {
            display: true,
            drawOnChartArea: false,
            drawTicks: false,
            
          },
          
          scaleLabel: {
            display: true,
          },
          ticks: {
            padding: 10,
            min: 0,
            max: 100,
            stepSize: 20,
            callback: function(value: any, index: any, values: any) {
              return value + "%";
            }
          }
        }
      ],
      xAxes: [
        {
          gridLines: {
            display: true
          },
          offset: true,
          ticks: {
            
            callback: function(value: any, index: any, values: any) {
              return value;
            }
          }
        }
      ]
    },
    tooltips: {
      yAlign: "top",
      backgroundColor: "white",
      bodyFontSize: 0,
      titleFontColor: "#4c4c4c",
      titleFontSize: 14,
      titleFontStyle: "normal",
      titleMarginBottom: 0,
      shadowOffsetX: 3,
      shadowOffsetY: 3,
      shadowBlur: 10,
      shadowColor: "rgba(0, 0, 0, 0.2)",
      callbacks: {
        
        title: function(tooltipItems: any, data: any) {
          return tooltipItems[0].yLabel.toFixed(0) + "%";
        },
        label: (tooltipItem: any) => {
          return null;
        }
      }
    }
  };

  private genDatacollection(
    data: any,
    fillColor: string,
    borderColor: string,
    pointColor: string
  ) {
    let scores = [];
    let lessons = [];
    if (data !== null && data.Scores !== null && data.Scores.length>0) {
      scores = data.Scores.slice();
    }

    if (data !== null && data.Lessons !== null && data.Lessons.length>0) {
      lessons = data.Lessons.slice();
    }

    let datacollection = {
      labels: lessons,
      datasets: [
        {
          label: "",
          data: scores,
          backgroundColor: fillColor,
          borderColor: borderColor,
          pointBackgroundColor: pointColor,
          pointBorderColor: pointColor,
          borderWidth: 2,
          fill: true,
          lineTension: 0,
        }
      ]
    };
    return datacollection;
  }

  private legendOnClick(id: string) {
    if (id === "overall") {
      this.datacollection = this.genDatacollection(
        this.teamPerformanceOverall,
        "rgba(139,223,245,.4)",
        "rgba(0,140,177,.3)",
        "rgb(0,140,177)"
      );
    } else if (id === "pacing") {
      this.datacollection = this.genDatacollection(
        this.teamPerformancePace,
        "rgba(215,255,222,.4)",
        "rgba(56,209,122,.3)",
        "rgb(25,173,89)"
      );
    } else if (id === "conciseness") {
      this.datacollection = this.genDatacollection(
        this.teamPerformanceConciseness,
        "rgba(255,235,153,.4)",
        "rgba(255,204,0,.3)",
        "rgb(247,183,0)"
      );
    } else if (id === "filler") {
      this.datacollection = this.genDatacollection(
        this.teamPerformanceFillers,
        "rgba(255,190,190,.5)",
        "rgba(247,70,87,.3)",
        "rgb(247,70,87)"
      );
    }
    this.currentChart = id;
  }

  get isEmpty() {
    if (this.currentChart === "overall") {
      return this.checkEmpty(this.teamPerformanceOverall);
    } else if (this.currentChart === "pacing") {
      return this.checkEmpty(this.teamPerformancePace);
    } else if (this.currentChart === "conciseness") {
      return this.checkEmpty(this.teamPerformanceConciseness);
    } else if (this.currentChart === "filler") {
      return this.checkEmpty(this.teamPerformanceFillers);
    } else return true;
  }

  private checkEmpty(data?: any) {
    if (data == null || data.Scores == null || !data.Scores.length) return true;
    else return false;
  }

  @Watch("teamPerformanceOverall")
  private teamPerformanceOverallData() {

    this.dataUpdated = true;
    this.legendOnClick("overall");
  }
}
